module.exports = __webpack_public_path__ + "e013b81c4c6d0566b631206fa2b67026.svg";